import React, { Component } from 'react';

export class BlurBackground extends Component {
  render() {
    return <div className="landingPage-modal">{this.props.children}</div>;
  }
}
